import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const StockInformation = ({ info }) => (
    <Row className="mt-4">
        <Col>
            <Card className="shadow-sm">
                <Card.Header as="h5" className="bg-primary text-white">Stock Information</Card.Header>
                <Card.Body>
                    <Card.Title>{info.name} ({info.symbol})</Card.Title>
                    <Card.Text>{info.description}</Card.Text>
                    <Card.Text>Industry: {info.industry}</Card.Text>
                    <Card.Text>Sector: {info.sector}</Card.Text>
                    <Card.Text><a href={info.summary_quote}>More quote info</a></Card.Text>
                </Card.Body>
            </Card>
        </Col>
    </Row>
);

export default StockInformation;